<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaHorarios"
      :titulo="$t ('Horarios')"
      icono="mdi-folder-clock-outline"
      tabla="hor"
      :campos="['id_hor-', 'des+']"
      busqueda-rapida
      :titulo-crud="$t ('horario')"
      :evento-despues-guardar-formulario-datos="despuesGuardarFormularioDatosTarifas"
      :formulario-datos-api-props="{ anchoMaximo: '950', sinMargenes: true }"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
      @montado="montadoTablaDatos"
    >
      <!-- F O R M U L A R I O -->

      <template v-slot:default="{ definicionCampos, datosRegistro, esAccionEliminar }">
        <v-container class="mt-5 px-6">
          <v-row>
            <v-col>
              <CampoFormularioDatos nombre-campo="des" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
              <!-- <CampoFormularioDatos nombre-campo="vis" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" /> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0">

              <!-- L I S T A   D E   F R A N J A S -->

              <div class="mt-n3 mb-2">{{ $t ('Lista de franjas horarias') }}</div>
              <TablaDatosAPI
                icono="mdi-clock-start"
                tabla="frahor"
                :campos="['dia', 'ini', 'fin', 'estmax']"
                :parametros="parametros_tabla_relacionada"
                modo-memoria
                titulo-crud="franja de horario"
                :permitir-anadir="!esAccionEliminar"
                :permitir-modificar="!esAccionEliminar"
                :permitir-eliminar="!esAccionEliminar"
                dense
                @cambios="cambiosEnTablaRelacionada (datosRegistro)"
                @montado="montadoTablaDatos"
                >
              </TablaDatosAPI>
              <div style="height: 15px"></div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from "@/components/CampoFormularioDatos.vue";
import api from '@/api'

export default {
  components: { TablaDatosAPI, CampoFormularioDatos },
  data() {
    return {
      tablasDatos: [],
    }
  },
  methods: {
    montadoTablaDatos (tablaDatos) {
      this.tablasDatos [tablaDatos.tabla] = tablaDatos;
    },
    cambiosEnTablaRelacionada (datosRegistroTarifa) {
      if (this.tablasDatos ['frahor'].hayCambiosModoMemoria())
        this.$set (datosRegistroTarifa, 'ctr__AUX', true); // ctr = Cambios en Tabla relacionada
      else
        this.$delete (datosRegistroTarifa, 'ctr__AUX');
    },
    despuesGuardarFormularioDatosTarifas (formularioDatosAPI) {
      api.loteCambiosRegistrosTablaVista ('frahor', this.tablasDatos ['frahor'].loteCambiosRegistros((registro) => { registro.id_hor = formularioDatosAPI.datosRegistro ['id_hor'] }));
    },
  },
  computed: {
    parametros_tabla_relacionada() {
      return {
        idHorario: { valor: this.tablasDatos['hor'].formulario.datosRegistro ['id_hor'] ?? 0, descripcion: '' }
      };
    },
  }
};
</script>

<style>
</style>